export default "__VITE_ASSET__Bgp$VG6b__"